module.exports = __webpack_public_path__ + "static/image/main/card/image-6.ver2_0_2.png?f5076728";